import type { IDepartment } from '@/interfaces'

export class Department implements IDepartment {
	id: string
	name: string
	description: string
	constructor({ id, name, description }: IDepartment) {
		this.id = id
		this.name = name
		this.description = description
	}
}
